import { render } from "./DownloadData.vue?vue&type=template&id=9b3ffe2a&scoped=true"
import script from "./DownloadData.vue?vue&type=script&lang=js"
export * from "./DownloadData.vue?vue&type=script&lang=js"

import "./DownloadData.vue?vue&type=style&index=0&id=9b3ffe2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9b3ffe2a"

export default script